import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import { get_all_project_tasks } from "../../../../Controllers/Projects/Tasks";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Projects/Tasks/tables";
import headers from "../../../../Data/Tables/Projects/Tasks/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { useParams } from "react-router-dom";
import Table from "../../../../Componets/Table";
import Progresscircle from "../../../../Componets/Progress";
import ProjectsTasksTab from "../../../../Data/Tables/Projects/Tasks/tabs";

const ProjectsTasksTable = () => {
  const { project } = useParams();

  headers.components[
    headers?.components?.length - 1
  ].path = `/app/projects/tasks/add/${project}`;

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [projectData, setProjectData] = useState();
  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        project: project,
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        project_status: tabledata?.project_status,
        start_date: tabledata?.start_date,
        end_date: tabledata?.end_date,
        status: tabledata?.status,
      };

      const projects = await get_all_project_tasks(data);
      if (projects?.status) {
        let data = [];

        projects?.data?.tasks?.map((value, index) => {
          data?.push({
            _id: value?._id,
            Number: (
              <TableImage image={value?.image} name={`#TASK${value?.number}`} />
            ),
            Name: value?.name,
            Job: value?.project_job?.name,
            Expense: value?.expense,
            "Task Status":
              value?.task_status == 1
                ? "Pending"
                : value?.task_status == 2
                ? "Ongoing"
                : value?.task_status == 3
                ? "Completed"
                : "Cancelled",
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/projects/tasks/edit/${project}/${value?._id}`}
                id={value?._id}
                api="delete-job"
                actiondata={actiondata}
              />
            ),
          });
        });

        setBody(data);
        setProjectData(projects?.data?.project);
        setLoader(false);
      } else {
        toast?.error(projects?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <ProjectsTasksTab projectData={projectData} />
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default ProjectsTasksTable;
